export default __webpack_public_path__ + "static/media/left-arrow-head.fde9ee13.svg";